import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import type { SubmitSpotQuoteParams } from '../infra/SpotQuoteMapper'
import { SpotQuoteRepository, type BookNowResult } from '../infra/SpotQuoteRepository'

export type BookNowSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function bookNowSpotQuoteFactory({
  spotQuoteRepository,
}: BookNowSpotQuoteFactoryDependencies) {
  return async function bookNow(
    spotQuote: SubmitSpotQuoteParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await spotQuoteRepository.bookNowSpotQuote(spotQuote, config)
    } catch (error) {
      sentry.log(error)
      throw new Error("Couldn't book. Please refresh the page", { cause: error as Error })
    }
  }
}

export function bookNowSpotQuote(
  spotQuote: SubmitSpotQuoteParams,
  config?: { signal?: AbortSignal }
): Promise<BookNowResult> {
  const httpClient = new HttpClient(API_URL)
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const bookNow = bookNowSpotQuoteFactory({ spotQuoteRepository })

  return bookNow(spotQuote, config)
}
